import { WishlistPageT } from '../../lib/types/sections';
import { FC, useMemo } from 'react';
import { useAppSelector } from '../../lib/store/hooks';
import { useContainerQuery } from '../../lib/hooks/endUserHooks/useContainerQuery';
import { EndUserWishlistTilesDesktop } from './components/EndUserWishlistTilesDesktop';
import { EndUserWishlistTilesMobile } from './components/EndUserWishlistTilesMobile';
import { useGetCampaignObjectPositions } from '../../lib/hooks/endUserHooks/useGetCampaignObjectPositions';
import {
  CAMPAIGN_POSITION_ELEMENT_OPTIONS,
  CAMPAIGN_POSITION_PAGES_OPTIONS,
  CAMPAIGN_POSITION_SECTION_OPTIONS,
} from '../campaignDetails/hooks/useGetPositionOption';

type Props = {
  content?: WishlistPageT;
};
export const EndUserWishlistTiles: FC<Props> = ({ content }) => {
  const { wishlistProducts, demandArea } = useAppSelector(({ endUser }) => endUser);
  const { isMobile } = useContainerQuery();

  const demandAreas = demandArea?.listDemandArea || [];

  const { foundObjects } = useGetCampaignObjectPositions({
    page: CAMPAIGN_POSITION_PAGES_OPTIONS.WISHLIST_PAGE,
    sections: [CAMPAIGN_POSITION_SECTION_OPTIONS.HOUSE],
    elements: [
      CAMPAIGN_POSITION_ELEMENT_OPTIONS.DA_HEADLINE,
      CAMPAIGN_POSITION_ELEMENT_OPTIONS.HEADLINE,
    ],
  });

  const updatedDemandAreasWithCampaignObjects = useMemo(() => {
    if (foundObjects.length && demandAreas) {
      return demandAreas.map((demandArea) => {
        const foundCampaignObject = foundObjects.find(
          (obj) => obj.demandAreaId === demandArea.id,
        );

        return {
          ...demandArea,
          campaignObject: foundCampaignObject ? foundCampaignObject : null,
        };
      });
    } else {
      return demandAreas;
    }
  }, [foundObjects, demandAreas]);

  const headlineCampaignObject = useMemo(() => {
    return foundObjects.find(
      (obj) => obj.type === CAMPAIGN_POSITION_ELEMENT_OPTIONS.HEADLINE,
    );
  }, [foundObjects]);

  return (
    <>
      {isMobile ? (
        <EndUserWishlistTilesMobile
          demandAreas={updatedDemandAreasWithCampaignObjects}
          content={content}
          headlineCampaignObject={headlineCampaignObject}
        />
      ) : (
        <EndUserWishlistTilesDesktop
          content={content}
          wishlistData={wishlistProducts}
          demandAreas={updatedDemandAreasWithCampaignObjects}
          headlineCampaignObject={headlineCampaignObject}
        />
      )}
    </>
  );
};
